import { StateController } from 'state-controller';
import { ProductionListActions } from 'pages/production/controllers/production-list-controller/production-list.controller';
import { ProductionStatusEnum } from 'types/status-enums';
import { AppState } from 'redux/store';
import { notify } from 'notifications';
import { PermissionGuardActions } from 'modules/permission-guard/permission-guard.controller';
import { AccessLevel, Permission } from 'services/permission.model';
import { LocationTheProductionStatusIsChangingFrom } from 'types/common-enums';
import { Actions as ProductionWorkflowActions } from 'pages/production-workflow/controllers/production-workflow.controller';
import { ProductionWorkflowService } from 'services/production-workflow.service';
import { IdName } from 'types/common-types';

export type CancelProductionWithFromStockOrToDoStatusModalState = {
  isOpen: boolean;
  location: string;
  isLoading: boolean;
  productionTitle: string;
  status: ProductionStatusEnum;
  productionIdToUpdate: string;
  productionIdToLoadDataFor: string;
  tasks: Array<IdName & { status: ProductionStatusEnum }>;
  components: Array<IdName & { status: ProductionStatusEnum }>;
};

const defaultState: CancelProductionWithFromStockOrToDoStatusModalState = {
  isOpen: false,
  location: '',
  isLoading: false,
  productionTitle: '',
  productionIdToUpdate: '',
  status: ProductionStatusEnum.Canceled,
  tasks: [],
  components: [],
  productionIdToLoadDataFor: '',
};

const stateController = new StateController<CancelProductionWithFromStockOrToDoStatusModalState>(
  'CANCEL_PRODUCTION_WITH_FROM_STOCK_OR_TO_DO_STATUS_MODAL',
  defaultState,
);

export class CancelProductionWithFromStockOrToDoStatusModalActions {
  public static openModal(
    productionIdToUpdate: string | undefined,
    productionIdToLoadDataFor: string | undefined,
    status: ProductionStatusEnum,
    productionTitle: string,
    location: string,
    tasks: Array<IdName & { status: ProductionStatusEnum }>,
    components: Array<IdName & { status: ProductionStatusEnum }>,
  ) {
    return (dispatch) => {
      if (!dispatch(PermissionGuardActions.checkPermissionAndShowModal(Permission.webProductionEdit, [AccessLevel.access]))) {
        return;
      }
      dispatch(
        stateController.setState((prev) => ({
          ...prev,
          isOpen: true,
          productionIdToUpdate,
          productionTitle,
          status,
          location,
          tasks,
          components,
          productionIdToLoadDataFor,
        })),
      );
    };
  }

  public static closeModal() {
    return async (dispatch) => {
      dispatch(stateController.setState({ isOpen: false }));
      setTimeout(() => dispatch(stateController.setState({ ...defaultState })), 100);
    };
  }

  public static onCancel() {
    return async (dispatch, getState: () => AppState) => {
      const { productionIdToUpdate, productionIdToLoadDataFor, status, location, tasks, components } =
        getState().production.cancelProductionWithFromStockOrToDoStatusModal;
      dispatch(stateController.setState({ isLoading: true }));

      if (location === LocationTheProductionStatusIsChangingFrom.WorkflowItem) {
        const tasksToCloseIds = tasks.map((t) => t.id);
        const componentsToCloseIds = components.map((c) => c.id);
        await ProductionWorkflowService.cancelProductionTasks(productionIdToUpdate, tasksToCloseIds, componentsToCloseIds);

        await dispatch(ProductionWorkflowActions.silentLoad({ id: productionIdToLoadDataFor }));

        dispatch(CancelProductionWithFromStockOrToDoStatusModalActions.closeModal());

        return;
      }
      try {
        await dispatch(ProductionListActions.updateProductionAfterServerUpdate(productionIdToUpdate, { status }, false));
      } catch (error) {
        notify.error(error.message);
      }

      dispatch(CancelProductionWithFromStockOrToDoStatusModalActions.closeModal());
    };
  }
}

export const reducer = stateController.getReducer();
